var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/hooks/useLegacyCaregiver.tsx";
import React, { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CaregiverInvitationErrorCode, LLUInvitationStatus } from 'Enums';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { addConnection, removeConnection as removeConnectionService, removeInvitation, resendInvitation } from 'Services/llu';
const useLegacyCaregiver = () => {
  const removeCaregiverConnection = useCallback(async caregiverConnection => {
    return removeConnectionService(caregiverConnection.id);
  }, []);
  const removeCaregiverInvitation = useCallback(async caregiverInvitation => {
    const {
      invitationId
    } = caregiverInvitation;
    await removeInvitation(invitationId);
  }, []);
  const resendCaregiverInvite = useCallback(async caregiverInvitation => {
    await resendInvitation(caregiverInvitation.invitationId);
  }, []);
  const inviteCaregiver = useCallback(async (firstName, lastName, email) => {
    const auth = store.getState().auth;
    const {
      regions
    } = store.getState().config;
    const {
      status,
      pendingConnectionInvitation
    } = await addConnection(firstName, lastName, email, auth, regions ?? {});
    if (pendingConnectionInvitation) {
      const caregiverInvitation = {
        caregiverId: pendingConnectionInvitation.receiver.accountId,
        email: pendingConnectionInvitation.receiver.email,
        firstName: pendingConnectionInvitation.receiver.firstName,
        lastName: pendingConnectionInvitation.receiver.lastName,
        invitationId: pendingConnectionInvitation.id
      };
      return {
        caregiverInvitation
      };
    }
    switch (status) {
      case LLUInvitationStatus.ALREADY_SENT:
        return {
          errorCode: CaregiverInvitationErrorCode.RESEND_NOT_ALLOWED
        };
      case LLUInvitationStatus.HCP_REJECTED:
        return {
          errorCode: CaregiverInvitationErrorCode.FORBIDDEN_ACCOUNT_ROLE_ERROR
        };
      case LLUInvitationStatus.INVALID_REGION:
        return {
          errorCode: CaregiverInvitationErrorCode.CAREGIVER_IN_DIFFERENT_COUNTRY
        };
      default:
        return {
          errorCode: CaregiverInvitationErrorCode.UNKNOWN
        };
    }
  }, []);
  const showRemoveInvitationConfirmationModal = useCallback(onRemoveClick => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        buttonLayout: 'column',
        details: /*#__PURE__*/React.createElement(Stack, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 93,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.strong",
          fontSize: "$bodyBase.strong",
          testID: "RemoveConnectionModal.title",
          marginBottom: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 94,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.removeConnection.title')), /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.default",
          fontSize: "$bodyBase.default",
          testID: "RemoveConnectionModal.body",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.removeConnection.body'))),
        primaryAction: {
          label: i18n.t('Global.microcopy.common.removeCap'),
          destructive: true,
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onRemoveClick();
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => store.dispatch({
            type: CLOSE_MODAL
          })
        },
        testID: 'RemoveConnectionModal'
      }
    });
  }, []);
  const showStopSharingModal = useCallback(onRemoveClick => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        buttonLayout: 'column',
        details: /*#__PURE__*/React.createElement(Stack, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 141,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.strong",
          fontSize: "$bodyBase.strong",
          testID: "StopSharingModal.title",
          marginBottom: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 142,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.stopSharing.title')), /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.default",
          fontSize: "$bodyBase.default",
          testID: "StopSharingModal.body",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 151,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.stopSharing.body'))),
        primaryAction: {
          label: i18n.t('Global.modals.stopSharing.title'),
          destructive: true,
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onRemoveClick();
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => store.dispatch({
            type: CLOSE_MODAL
          })
        },
        testID: 'StopSharingModal'
      }
    });
  }, []);
  return {
    inviteCaregiver,
    resendCaregiverInvite,
    removeCaregiverConnection,
    removeCaregiverInvitation,
    showRemoveInvitationConfirmationModal,
    showStopSharingModal
  };
};
export default useLegacyCaregiver;